import {
  CustomDetector,
  DetectorOptions,
} from 'i18next-browser-languagedetector'

class HashQueryLocaleDetector implements CustomDetector {
  name: string

  constructor() {
    this.name = 'routerquerystring'
  }

  //lookup(options: DetectorOptions): string | undefined;
  //cacheUserLanguage?(lng: string, options: DetectorOptions): void;

  lookup(options: DetectorOptions): string | undefined {
    if (options.lookupQuerystring == null) {
      // not configured properly
      return undefined
    }
    if (window == null) {
      // no window
      return undefined
    }

    //const location = window.location
    const search = getHashRouterQuery(window.location)
    const searchParams: URLSearchParams = new URLSearchParams(search)
    const param_locale: string | null = searchParams.get(
      options.lookupQuerystring
    )

    if (param_locale != null && param_locale !== '') {
      // Locale parameter found
      return param_locale
    } else {
      // Nothing found
      return undefined
    }
  }

  cacheUserLanguage(lng: string, options: DetectorOptions) {
    //console.log(`Cache user language: ${lng}; options: ${options}`)
  }
}

/** Helper function to get query param contained in a hash part of the Location */
function getHashRouterQuery(location: Location): string | undefined {
  //const search = location.search
  const queryStartIndex: number = location.hash.indexOf('?')
  if (queryStartIndex > 0) {
    // includes the '?'
    const hashRouterQuery = location.hash.substring(queryStartIndex)
    return hashRouterQuery
  } else {
    return undefined
  }
}

export default HashQueryLocaleDetector
